module.exports = {
  footerText: 'Power By HakimanSBF™ © 2020-2024 Version3',
}
